export const locale = {
    lang: 'en',
    data: {
        RESULT: 'Score',
        CANCEL: 'Close',
    }
};
